/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useState } from 'react';
import { ContactUs } from 'components/templates/contact-us';
import { NextSeo } from 'next-seo';
import { API_KEY, LANGUAGE_OPTIONS, TAXIMAIL_API } from 'libs/constants';
import axios from 'axios';
import { Modal } from 'components/organisms/modal';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/atoms/button';

const ContactUsPage: React.FC = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState('');

  const handleCloseThankyouModal = useCallback(() => {
    setShowSuccessModal(false);
  }, []);

  const handleCloseErrorModal = useCallback(() => {
    setShowErrorModal(false);
  }, []);

  const handleSubmit = useCallback(async submitData => {
    const http = axios.create({
      baseURL: TAXIMAIL_API.BASE_URL,
    });
    try {
      submitData.auth = API_KEY;
      setIsLoading(true);
      const sendResult = await http.post(TAXIMAIL_API.TRANSACTIONAL, submitData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      setIsLoading(false);
      // show thank you dialog
      if (sendResult) {
        // show modal
        setShowSuccessModal(true);
      }
      // login first
      /* const loginPayload = {
        apiKey: TAXIMAIL_API.API_KEY,
        secretKey: TAXIMAIL_API.SECRET_KEY,
      };
      const loginResult = await http.post(TAXIMAIL_API.LOGIN, loginPayload, {
        headers: {
          Authorization: API_KEY,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      if (loginResult.data) {
        const sessionId = loginResult.data.session_id;
        // send email using sessionId
      } */
    } catch (e: any) {
      setIsLoading(false);
      let errorMessage = e.message;
      if (e.response) {
        if (e.response.data.error) {
          errorMessage = e.response.data.error;
        } else {
          errorMessage = e.response.data;
        }
      }
      setApiErrorMessage(errorMessage);
      setShowErrorModal(true);
    }
  }, []);

  return (
    <>
      <NextSeo title={t('contact.title')} />
      <ContactUs onSubmit={handleSubmit} isSubmitting={isLoading} />
      <Modal opened={showSuccessModal} noHeader={true} noCloseButton={true} noBackground={true}>
        <div className="p-thankyou-modal">
          <div className="p-thankyou-modal__overlay" onClick={handleCloseThankyouModal}></div>
          <div className="p-thankyou-modal__content">
            <div className="p-thankyou-modal__content-icon">
              <img src="/images/thankyou.svg" alt="thank you" width="140" height="140" />
            </div>
            <p className="p-thankyou-modal__content-title">{t('contact.thankyou.title')}</p>
            <p
              className="p-thankyou-modal__content-description"
              dangerouslySetInnerHTML={{ __html: t('contact.thankyou.description') }}
            />
            <div className="p-thankyou-modal__content-button">
              <Button onClick={handleCloseThankyouModal}>{t('general.close')}</Button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal opened={showErrorModal} noHeader={true} noCloseButton={true} noBackground={true}>
        <div className="p-thankyou-modal">
          <div className="p-thankyou-modal__overlay" onClick={handleCloseErrorModal}></div>
          <div className="p-thankyou-modal__content">
            <p className="p-thankyou-modal__content-title">{t('contact.error')}</p>
            <p className="p-thankyou-modal__content-description">
              <code>{apiErrorMessage}</code>
            </p>
            <div className="p-thankyou-modal__content-button">
              <Button onClick={handleCloseErrorModal}>{t('general.close')}</Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ContactUsPage;

export async function getStaticPaths() {
  // generate path for static generation
  const paths: any = [];
  LANGUAGE_OPTIONS.forEach((item: any) => {
    paths.push({
      params: {
        lang: item.value,
      },
    });
  });
  return { paths, fallback: false };
}

export async function getStaticProps(args: any) {
  const { lang } = args.params;

  return {
    props: {
      lang,
    },
  };
}
